import { data } from "react-router-dom";
import authInstance from "../utilities/axios/authInstance";
import globalInstance from "../utilities/axios/globalInstance";

export const changePassword = (passwordData) => authInstance.post('auth/change-password', passwordData);

export const login = (user) => globalInstance.post('/auth/login', user);

export const forgotPassword = (data) => globalInstance.post('auth/forgot-password', data);

export const passwordReset = (data) => globalInstance.put('auth/reset-password', data);